import styled from "@emotion/styled";

import { VideoSectionSearchResultListItem } from "./item";

export const StyledVideoSectionSearchResultListItem = styled(VideoSectionSearchResultListItem)``;

export const Container = styled.div`
  padding-block: 20px;

  border-block: 1px solid rgba(0, 0, 0, 0.2);

  ${StyledVideoSectionSearchResultListItem}:not(:last-child) {
    margin-block-end: 20px;
  }
`;

export const Title = styled.p`
  margin-block-end: 4px;

  font-size: 14px;
`;
